import apiBearer from '../api-bearer';
import type { MetaRequest } from '../model';
import type {
  UserCurrentResponse,
  UsersAgreementRequest,
  UsersChangePasswordRequest,
  UsersCreateRequest,
  UsersCreateResponse,
  UsersDataDetailResponse,
  UsersDataResponse,
  UsersHeadResponse,
  UsersUpdateRequest,
} from './users.model';

export const getUsersList = async (payload?: MetaRequest): Promise<UsersDataResponse> => {
  const { data } = await apiBearer.get<UsersDataResponse>('/users', {
    params: {
      include: 'employee',
      ...payload,
    },
  });
  return data;
};

export const getUsersCurrent = async (payload?: MetaRequest): Promise<UserCurrentResponse> => {
  const { data } = await apiBearer.get<UserCurrentResponse>('/users/current', {
    params: {
      include: 'employee',
      with_permissions: 1,
      ...payload,
    },
  });
  return data;
};

export const getUsersDetail = async (id?: string): Promise<UsersDataDetailResponse> => {
  const { data } = await apiBearer.get<UsersDataDetailResponse>(`/users/${id}`, {
    params: {
      include: 'employee.photo,employee',
    },
  });
  return data;
};

export const getUsersHead = async (id?: string): Promise<UsersHeadResponse> => {
  const { data } = await apiBearer.get<UsersHeadResponse>(`/users/${id}/head`, {
    params: {
      include: 'employee.photo',
    },
  });
  return data;
};

export const postUsersCreate = async (
  payload: UsersCreateRequest
): Promise<UsersCreateResponse> => {
  const { data } = await apiBearer.post<UsersCreateResponse>(`/users/`, payload);
  return data;
};

export const putUsersUpdate = async ({
  id,
  ...payload
}: UsersUpdateRequest): Promise<UsersCreateResponse> => {
  const { data } = await apiBearer.put<UsersCreateResponse>(`/users/${id}`, payload);
  return data;
};

export const putUsersChangePassword = async (
  payload: UsersChangePasswordRequest
): Promise<UsersCreateResponse> => {
  const { data } = await apiBearer.put<UsersCreateResponse>(`/users/change-password`, payload);
  return data;
};

export const putUsersDelete = async (id: string): Promise<UsersCreateResponse> => {
  const { data } = await apiBearer.delete<UsersCreateResponse>(`/users/${id}`);
  return data;
};

export const putUsersAgreement = async (payload: UsersAgreementRequest) => {
  const { data } = await apiBearer.put(`/users/accept-agreement`, payload);
  return data;
};
